import { type ComponentProps, forwardRef } from 'react';
import { type ScrollViewInstance } from 'react-native';

import { useA11ySelector } from '@sg/a11y-helpers';
import { Scrollspy, useContainerSpacing, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridNav = forwardRef<ScrollViewInstance, MenuCategoriesGridNavProps>(
  (props, ref) => {
    const { children, ...restProps } = props;

    const a11ySelector = useA11ySelector('menu.nav');

    const { currentBreakpoint } = useResponsive();
    const containerSpacing = useContainerSpacing();

    return (
      <Scrollspy.Nav
        ref={ref}
        stagePadding={currentBreakpoint.isLG ? undefined : containerSpacing}
        {...a11ySelector.props}
        {...restProps}
      >
        {children}
      </Scrollspy.Nav>
    );
  },
);

MenuCategoriesGridNav.displayName = 'MenuCategoriesGridNav';

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuCategoriesGridNavProps = ComponentProps<typeof Scrollspy.Nav>;
